'use client';

import { useState, useEffect } from 'react';
import { pageView } from '@/lib/analytics';

export function ConsentBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('analytics-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('analytics-consent', 'accepted');
    setShowBanner(false);

    // Grant analytics after consent
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
      });
      // Send current page view now that consent was granted (initial load may have been blocked)
      pageView(window.location.pathname + window.location.search, document.title);
    }
  };

  const handleDecline = () => {
    localStorage.setItem('analytics-consent', 'declined');
    setShowBanner(false);

    // Explicitly deny analytics
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
      });
    }
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:right-4 md:max-w-md bg-card text-card-foreground rounded-lg border border-border shadow-lg">
      <div className="p-4">
        <h3 className="font-semibold mb-2">Cookies e Privacidade</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Usamos cookies e Google Analytics para melhorar sua experiência.
          Você aceita o uso desses serviços?
        </p>
        <div className="flex gap-2">
          <button
            type="button"
            className="flex-1 rounded-lg border border-border bg-primary text-primary-foreground py-2 px-3 font-medium hover:opacity-90"
            onClick={handleAccept}
          >
            Aceitar
          </button>
          <button
            type="button"
            className="flex-1 rounded-lg border border-border bg-muted text-foreground py-2 px-3 font-medium hover:bg-accent"
            onClick={handleDecline}
          >
            Recusar
          </button>
        </div>
      </div>
    </div>
  );
}
